// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m7Fh86PD5wQVsqCTSuPE{justify-content:space-between;width:100%;display:flex}.V4NG5RTqz2A2N4EtdrKx{margin-left:auto}.VGmiWYJTIolimmQ1jOba{margin-right:8px}.e3SFoXsYNiYeSMBVQGkH{background-size:contain;border-radius:6px;height:264px;margin:16px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `m7Fh86PD5wQVsqCTSuPE`,
	"rightContent": `V4NG5RTqz2A2N4EtdrKx`,
	"cancelButton": `VGmiWYJTIolimmQ1jOba`,
	"validateContentImg": `e3SFoXsYNiYeSMBVQGkH`
};
export default ___CSS_LOADER_EXPORT___;
